import api from './api';

export interface User {
  id: number;
  email: string;
  name: string;
  createdAt: string;
}

export const userService = {
  getAll: () => api.get('/users'),
  create: (data: { email: string; password: string; name: string }) => 
    api.post('/users', data),
  delete: (id: number) => api.delete(`/users/${id}`),
  changePassword: (data: { oldPassword: string; newPassword: string }) =>
    api.post('/users/change-password', data),
};
